<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">{{ $t("Programas Sociais") }}</h1>

    <b-card class="shadow">
      <div class="row animate__animated animate__fadeIn" v-if="!add">
        <div class="col-12">
          <div class="d-flex">
            <div class="mr-auto">
              <button class="btn btn-sm btn-primary" @click="add = true">
                <i class="fas fa-plus-square" />
                {{ $t("Cadastrar") }}
              </button>
            </div>
            <div>
              <b-button
                :title="$t('Importar Beneficiários')"
                v-b-modal.modalImportar
                class="py-2 mb-3"
                size="sm"
                type="button"
                v-b-tooltip.hover
                variant="default"
              >
                <i class="fas fa-file-upload"></i>
                {{ $t("Importar Beneficiários") }}
              </b-button>
              <b-button
                class="py-2 mb-3"
                variant="default"
                @click="exportar()"
                :title="$t('Exportar')"
                v-b-tooltip.hover
              >
                <i class="fas fa-file-excel"></i>
              </b-button>
            </div>
            <div>
              <div class="input-group mb-3">
                <b-input
                  :placeholder="$t('Type to search')"
                  class="form-control search-input"
                  type="text"
                  v-model="search"
                  v-on:change="getItens"
                  aria-describedby="input-search"
                />
                <div class="input-group-append" role="button">
                  <span class="input-group-text" id="input-search"
                    ><i class="fas fa-search search-icon"
                  /></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
          />
          <print-content>
            <b-table
              :fields="[
                {
                  key: 'nome',
                  label: $t('Detalhes'),
                },
                {
                  key: 'beneficiados',
                  label: $t('Beneficiados'),
                },
                {
                  key: 'cadastrado',
                  label: $t('Criado em'),
                },
                {
                  key: 'status',
                  label: $t('Status'),
                },
                {
                  key: 'actions',
                  label: '',
                  class: 'text-right no-print',
                  thStyle: { width: '95px', minWidth: '95px' },
                },
              ]"
              :items="itemList"
              :responsive="true"
              striped
              hover
              show-empty
              small
              outlined
              stacked="xs"
              table-class="mb-3"
            >
              <template v-slot:cell(nome)="data">
                Nome:
                <strong> {{ data.value }} </strong>
                <br />
                Protocolo:
                <strong> {{ data.item.protocolo }} </strong>
                <span v-if="data.item.valor">
                  <br />
                  Valor R$:
                  <strong>
                    {{ data.item.valor_formatado }}
                  </strong>
                </span>
              </template>
              <template v-slot:cell(beneficiados)="data">
                <strong>{{ data.value }}</strong>
              </template>
              <template v-slot:cell(cadastrado)="data">
                <strong>{{ data.value }}</strong>
              </template>
              <template v-slot:cell(status)="data">
                <span v-html="data.item.status_nome"></span>
              </template>

              <template v-slot:cell()="data">
                <b-button
                  :title="$t('Editar')"
                  :to="'/dashboard/programassociais/edit/' + data.item.id"
                  class="px-2 mb-0"
                  size="xs"
                  type="button"
                  v-b-tooltip.hover
                  variant="success"
                >
                  <i class="mdi mdi-square-edit-outline" />
                </b-button>
              </template>
              <template v-slot:empty="scope">
                <div class="text-center my-5">
                  <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                  />
                  <h3 class="bold">
                    {{ $t("No records found") }}
                  </h3>
                </div>
              </template>
            </b-table>
          </print-content>
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
              <div class="form-group d-inline-flex mb-0">
                <select
                  class="form-control"
                  style="width: 70px"
                  v-model="perPage"
                  v-on:change="getItens"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
              <div class="d-inline-flex ml-2">
                <b-pagination
                  :per-page="perPage"
                  :total-rows="pagination.total"
                  @change="changePage"
                  v-model="page"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
              <div class="float-lg-right">
                {{ $t("Showing page") }}
                {{ pagination.currentPage }}
                {{ $t("of") }}
                {{ pagination.totalPages }}
                {{ $t("pages in") }}
                {{ pagination.total }}
                {{ $t("records") }}
              </div>
            </div>
          </div>
        </div>

        <div class="box-btn-print no-print">
          <b-button
            v-if="!loading"
            :title="$t('Visualizar e Imprimir')"
            class="py-2"
            size="sm"
            type="button"
            v-b-tooltip.hover
            variant="primary"
            @click="print()"
          >
            <i class="fas fa-print"></i>
          </b-button>
        </div>
      </div>

      <Add v-else @voltar="add = false" @reload="getItens" />
    </b-card>

    <ModalImportar />
  </div>
</template>

<script>
import Add from "./Add";
import ModalImportar from "./ModalImportar";
export default {
  name: "ReadProgramasSociais",
  metaInfo() {
    return {
      title: this.$i18n.t("Programas Sociais"),
    };
  },
  components: {
    Add,
    ModalImportar,
  },
  data() {
    return {
      add: false,
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      itemList: [],
      participantes: [],
      filtro: null,
      user_id: null,
    };
  },
  mounted() {
    this.getItens();
  },
  methods: {
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getItens();
      }
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/programassociais", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    getItens() {
      this.loading = true;
      axios
        .get("api/dashboard/programassociais", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.itemList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getItens();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
